import { IconButton } from '@mui/material'
import { Timestamp } from '@weblite/ts-action/types'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PersianDate from 'persian-date'
import { FilledShare } from '$common/icons/filled-share'
import { MediaChannelListItem } from '$common/media-owner-list-item/media-channel-list-item'
import { UserListItem } from '$common/user-list-item'
import { MediaWappListItem } from '$common/media-owner-list-item/media-wapp-list-item'

interface Props {
  owner?: {
    id: string
    type: 'USER' | 'WAPP' | 'CHANNEL'
  }
  date?: Timestamp
  onShare?: () => unknown
}

export function MediaOwnerListItem({ owner, date, onShare }: Props) {
  const ShareButton = onShare ? (
    <IconButton
      sx={{ borderRadius: 0, width: '56px', height: '56px' }}
      size="large"
      onClick={e => {
        e.stopPropagation()
        onShare()
      }}
    >
      <FilledShare />
    </IconButton>
  ) : null

  const senderDate = date
    ? new PersianDate(date).format('D MMMM YYYY - H:m')
    : ''

  if (owner?.type === 'CHANNEL')
    return (
      <MediaChannelListItem
        channelId={owner.id}
        secondaryText={senderDate}
        secondaryActionComponent={ShareButton}
      />
    )
  if (owner?.type === 'WAPP')
    return (
      <MediaWappListItem
        wappId={owner.id}
        secondaryText={senderDate}
        secondaryActionComponent={ShareButton}
      />
    )

  return (
    <UserListItem
      userId={owner?.id}
      secondaryText={senderDate}
      isTransparent
      fullOpacity
    />
  )
}
